import { render, staticRenderFns } from "./overview_tab.vue?vue&type=template&id=475c328e"
import script from "./overview_tab.vue?vue&type=script&lang=js"
export * from "./overview_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports